module.exports = __webpack_public_path__ + "static/media/Level_2.fc41ff5b.png";